export default __webpack_public_path__ + "static/media/pokemon_shiny_rare.0a57d0ca.svg";